import React, { Fragment, useRef, useState } from "react";
import { Container, Grid, Box, Button } from "theme-ui";
import { Link, useStaticQuery, graphql } from "gatsby";
import { Icon } from "../../components/Icons";
import { Icon as Icons } from "../../optimizely-components/Utilities/Icons/Icon";
//import { keyframes } from '@emotion/react'
import { StaticImage } from "gatsby-plugin-image";
import { useSecureLinks } from "../../hooks/useSecureLinks";

export interface AccordionProps {
  panelTitle: string | JSX.Element;
  panelBody: string | JSX.Element;
  style?: React.CSSProperties;
  [key: string]: any;
}

/*
const letsRotate = keyframes`
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
  }

  100% {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
  }
`

const reverseRotate = keyframes`
0% {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
}

100% {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
}
`
const letSlideIn = keyframes`
  from {
    margin-left: 100%;
    width: 300%;
  }
  to {
    margin-left: 0%;
    width: 100%;
  }
`
*/

function NavAccordion({
  panelTitle,
  panelBody,
  style,
}: AccordionProps): JSX.Element {
  const [isActive, setActive] = useState("");
  const [isHeight, setHeight] = useState("0px");
  const [isRotate, setRotate] = useState<string>("");
  const content = useRef<HTMLDivElement>(null);

  function toggleAccordion() {
    setActive(isActive === "" ? "active" : "");
    setHeight(isActive === "active" ? "0px" : `100vh`);
    // setRotate(
    //   isActive === 'active'
    //     ? `${reverseRotate} 0.20s ease-in-out`
    //     : `${letsRotate} 0.20s ease-in-out`
    // )
  }

  return (
    <div
      sx={{
        display: "flex",
        flexDirection: "column",
        minWidth: "0",
        width: "100%",
        position: [`${isActive}` ? "absolute" : "relative", "relative"],
        top: [`${isActive}` ? "15px" : "0", "0"],
        height: [`${isActive}` ? "100vh" : "100%", "auto"],
        zIndex: [`${isActive}` ? "10000000" : "100", "100"],
        width: [`${isActive}` ? "95%" : "100%", "100%"],
        backgroundClip: "border-box",
        overflow: "auto",
        bg: "#232C3A",
        pb: "5px",
        ":last-child": {
          borderBottom: "none",
        },
        ":focus-within": {
          outline: "none",
        },
        ...style,
      }}
    >
      <Button
        sx={{
          outline: "none",
          border: "none",
          display: "flex",
          cursor: "pointer",
          px: "0",
          borderRadius: "0px",
          backgroundColor: "none",
          textAlign: "left",
          alignItems: "center",
          justifyContent: "space-between",
          background: "none",
          py: "5px",
          "&:hover": {
            transform: "none",
            outline: "none",
          },
          "&:focus": {
            outline: "1px solid #1A1818",
          },
        }}
        onClick={() => {
          toggleAccordion();
        }}
        role="button"
      >
        <Fragment>{panelTitle}</Fragment>
        <Icon
          name="chevron-right"
          id="chevron-right"
          alt="Chevron"
          width="15"
          height="15"
          viewBox="0 0 10 15"
          sx={{
            verticalAlign: "center",
            animation: `${isRotate}`,
            overflow: "scroll",
            animationTimingFunction: "linear",
            animationFillMode: "forwards",
            transformOrigin: "50% 55%",
            display: [null, null, "none"],
            mr: "10px",
            path: {
              fill: "#fff",
              stroke: "#fff",
            },
          }}
        />
      </Button>
      <div
        ref={content}
        sx={{
          maxHeight: `${isHeight}`,
          display: [isActive ? "block" : "none", null, "block"],
          overflow: "hidden",
          position: "relative",
          overflow: [`${isActive}` ? "visible" : "none", "visible"],
        }}
      >
        {panelBody}
      </div>
    </div>
  );
}

const SubNav = (): JSX.Element => {
  const [isActive, setActive] = useState("");
  const content = useRef<HTMLDivElement>(null);
  const secureLinks = useSecureLinks();
  return (
    <Fragment>
      <Container
        sx={{
          display: ["block", null, null, "flex"],
          justifyContent: "space-between",
          alignItems: "baseline",
          maxWidth: ["100%", "90%", "1360px"],
          px: "15px",
          pb: 4,
          pt: 0,
          height: [null, "fit-content", "100%"],
        }}
      >
        <NavAccordion
          panelTitle={
            <Fragment>
              <p
                sx={{
                  fontSize: "120%",
                  color: "#fff",
                  fontWeight: "500",
                  fontFamily: "neue-kabel, serif",
                  lineHeight: "1.2",
                  ml: [null, null, "20px"],
                  "&:focus": {
                    outline: "1px solid #fff",
                    border: "1px solid #fff",
                  },
                }}
              >
                Cash Money Loans
              </p>
            </Fragment>
          }
          panelBody={
            <Fragment>
              <ul
                aria-labelledby="sub-menu-heading"
                aria-label="Cash Money Loans"
                role="list"
                sx={{
                  ml: [isActive ? "100%" : 0, null, 0],
                  width: [isActive ? "300%" : "100%", null, "100%"],
                  animationDuration: [".5s", null, 0],
                  //animationName: [letSlideIn, null, 'none'],
                  animationDirection: "alternate",
                  borderTop: "2px solid #A9D4F1",
                  listStyle: "none",
                  minHeight: "100%",
                  paddingLeft: 0,
                  flexDirection: ["column", null, "unset"],
                  display: "block",
                  pt: ["20px", "10px"],
                  columns: [1, 2],
                }}
              >
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/line-of-credit/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Line of Credit
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/payday-loans/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Payday Loans
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/auto-equity-loans/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Auto Equity Loans
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/payday-loans/instant/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Instant Payday Loans
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/payday-loans/online-loans/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Online Payday Loans
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/cash-advances/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Cash Advance
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/online-loans/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Online Loans
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/loans/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Available Loans
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/personal-loans/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      mb: [2, 0],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Personal Loans
                  </Link>
                </li>
              </ul>
            </Fragment>
          }
          style={{
            borderBottom: "none",
            pb: 0,
            pt: "15px !important",
            button: {
              cursor: ["pointer", null, "auto"],
              justifyContent: ["space-between", null, "normal"],
              width: "100%",
            },
            div: {
              overflow: [null, null, "visible"],
              maxHeight: "100vh",
              mb: 0,
              mx: [null, null, "20px"],
              pt: 0,
              maxHeight: [null, null, "100%"],
            },
          }}
        />

        <NavAccordion
          panelTitle={
            <Fragment>
              <p
                sx={{
                  fontSize: "120%",
                  color: "#fff",
                  fontWeight: "500",
                  fontFamily: "neue-kabel, serif",
                  lineHeight: "1.2",
                  ml: [null, null, "20px"],
                  mt: [null, "15px", null],
                  "&:focus": {
                    outline: "1px solid #fff",
                    border: "1px solid #fff",
                  },
                }}
              >
                Store Services
              </p>
            </Fragment>
          }
          panelBody={
            <Fragment>
              <ul
                aria-labelledby="sub-menu-heading"
                role="list"
                aria-label="Store Services"
                sx={{
                  ml: [isActive ? "100%" : 0, null, 0],
                  width: [isActive ? "300%" : "100%", null, "100%"],
                  animationDuration: [".5s", null, 0],
                  //animationName: [letSlideIn, null, 'none'],
                  animationDirection: "alternate",
                  borderTop: "2px solid #A9D4F1",
                  listStyle: "none",
                  minHeight: "100%",
                  paddingLeft: 0,
                  flexDirection: ["column", null, "unset"],
                  pt: ["20px", "10px"],
                  display: "block",
                }}
              >
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/financial-services/money-order/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Western Union<sup>®</sup> Money Orders
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/financial-services/money-transfer/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Western Union<sup>®</sup> Money Transfers
                  </a>
                </li>
              </ul>
            </Fragment>
          }
          style={{
            borderBottom: "none",
            pb: 0,
            pt: "15px !important",
            button: {
              cursor: ["pointer", null, "auto"],
              justifyContent: ["space-between", null, "normal"],
              width: "100%",
            },
            div: {
              overflow: [null, null, "visible"],
              maxHeight: "100vh",
              mb: 0,
              mx: [null, null, "20px"],
              pt: 0,
              maxHeight: [null, null, "100%"],
            },
          }}
        />

        <NavAccordion
          panelTitle={
            <Fragment>
              <p
                sx={{
                  fontSize: "120%",
                  color: "#fff",
                  fontWeight: "500",
                  fontFamily: "neue-kabel, serif",
                  lineHeight: "1.2",
                  ml: [null, null, "20px"],
                  "&:focus": {
                    outline: "1px solid #fff",
                    border: "1px solid #fff",
                  },
                }}
              >
                Resources
              </p>
            </Fragment>
          }
          panelBody={
            <Fragment>
              <ul
                aria-labelledby="sub-menu-heading"
                role="list"
                aria-label="Resources"
                sx={{
                  ml: [isActive ? "100%" : 0, null, 0],
                  width: [isActive ? "300%" : "100%", null, "100%"],
                  animationDuration: [".5s", null, 0],
                  //animationName: [letSlideIn, null, 'none'],
                  animationDirection: "alternate",
                  borderTop: "2px solid #A9D4F1",
                  listStyle: "none",
                  minHeight: "100%",
                  paddingLeft: 0,
                  flexDirection: ["column", null, "unset"],
                  display: "block",
                  pt: ["20px", "10px"],
                  columns: [1, 2],
                }}
              >
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/faqs/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    FAQs
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/blogs/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Blogs
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/about-us/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    About Us
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/security-centre/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Security Centre
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/accessibility-statement/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Accessibility Statement
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/personal-loan-protection/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Loan Protection Plan
                  </a>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="/loan-protection-claim-forms/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Loan Protection Claims
                  </a>
                </li>
              </ul>
            </Fragment>
          }
          style={{
            borderBottom: "none",
            pb: 0,
            pt: "15px !important",
            button: {
              cursor: ["pointer", null, "auto"],
              justifyContent: ["space-between", null, "normal"],
              width: "100%",
            },
            div: {
              overflow: [null, null, "visible"],
              maxHeight: "100vh",
              mb: 0,
              mx: [null, null, "20px"],
              pt: 0,
              maxHeight: [null, null, "100%"],
            },
          }}
        />

        <NavAccordion
          panelTitle={
            <Fragment>
              <p
                sx={{
                  fontSize: "120%",
                  color: "#fff",
                  fontWeight: "500",
                  fontFamily: "neue-kabel, serif",
                  lineHeight: "1.2",
                  ml: [null, null, "20px"],
                  mt: [null, "15px", null],
                  "&:focus": {
                    outline: "1px solid #fff",
                    border: "1px solid #fff",
                  },
                }}
              >
                Connect with Us
              </p>
            </Fragment>
          }
          panelBody={
            <Fragment>
              <ul
                aria-labelledby="sub-menu-heading"
                aria-label="Connect with Us"
                role="list"
                sx={{
                  ml: [isActive ? "100%" : 0, null, 0],
                  width: [isActive ? "300%" : "100%", null, "100%"],
                  animationDuration: [".5s", null, 0],
                  //animationName: [letSlideIn, null, 'none'],
                  animationDirection: "alternate",
                  borderTop: "2px solid #A9D4F1",
                  listStyle: "none",
                  minHeight: "100%",
                  paddingLeft: 0,
                  pt: ["20px", "10px"],
                  flexDirection: ["column", null, "unset"],
                  display: "block",
                }}
              >
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <Link
                    to="/find-a-store/"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    Store Locations
                  </Link>
                </li>
                <li
                  role="listitem"
                  sx={{
                    mb: "15px",
                  }}
                >
                  <a
                    href="tel:18775266639"
                    sx={{
                      color: "#fff",
                      fontSize: ["16px", null, null, "14px"],
                      letterSpacing: 0,
                      "&:hover": {
                        color: "brand.powderBlue",
                      },
                    }}
                  >
                    <Icon
                      name={"phone-outlined"}
                      alt={"Call us"}
                      viewBox="0 5 20.355 20.394"
                      width={20}
                      sx={{
                        path: {
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: "1.5",
                        },
                      }}
                    />{" "}
                    1-877-526-6639
                  </a>
                </li>
                <ul sx={{ display: "flex" }}>
                  <li
                    role="listitem"
                    sx={{
                      mb: "15px",
                    }}
                  >
                    <ul sx={{ display: "flex" }}>
                      <li sx={{ mx: 1 }}>
                        <a href="https://www.facebook.com/cashmoney.ca/">
                          <Icons
                            size={25}
                            name={"facebook"}
                            color="white"
                            alt="facebook"
                          />
                        </a>
                      </li>
                      <li sx={{ mx: 1 }}>
                        <a href="https://www.instagram.com/cash_money1992/">
                          <Icons
                            size={25}
                            name={"instagram"}
                            color="white"
                            alt="instagram"
                          />
                        </a>
                      </li>
                      <li sx={{ mx: 1 }}>
                        <a href="https://www.linkedin.com/company/cash-money/">
                          <Icons
                            size={25}
                            name={"linkedin"}
                            color="white"
                            alt="linkedin"
                          />
                        </a>
                      </li>
                    </ul>
                    <ul
                      sx={{
                        display: "flex",
                        mt: 3,
                        maxWidth: "250px",
                        "& div": {
                          ml: "0px !important",
                          mr: "0px !important",
                        },
                      }}
                    >
                      <li sx={{ mr: 1 }}>
                        <a
                          href="https://itunes.apple.com/us/app/cash-money/id1180099405?mt=8"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <StaticImage
                            src="../../../images/layouts/legacy/app-button-apple-2.png"
                            alt="Apple App Store"
                            quality={100}
                            placeholder="none"
                            width={585}
                            height={180}
                            sx={{
                              "picture > img": {
                                objectFit: "contain !important",
                                height: "40px",
                              },
                              margin: [null, "0"],
                              width: "100%",
                            }}
                          />
                        </a>
                      </li>
                      <li sx={{ ml: 1 }}>
                        <a
                          href="https://play.google.com/store/apps/details?id=com.tigerfinancial.mobile.cashmoney"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <StaticImage
                            src="../../../images/layouts/legacy/app-button-google-2.png"
                            alt="Google Play Store "
                            quality={100}
                            placeholder="none"
                            width={585}
                            height={180}
                            sx={{
                              "picture > img": {
                                objectFit: "contain !important",
                                height: "40px",
                              },
                              margin: [null, "0"],
                              width: "100%",
                            }}
                          />
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </ul>
            </Fragment>
          }
          style={{
            height: "100%",
            borderBottom: "none",
            pb: 0,
            pt: "15px !important",
            button: {
              cursor: ["pointer", null, "none"],
              justifyContent: ["space-between", null, "normal"],
              width: "100%",
            },
            div: {
              overflow: [null, null, "visible"],
              maxHeight: "100vh",
              mx: [null, null, "20px"],
              mb: 0,
              pt: 0,
              maxHeight: [null, null, "100%"],
            },
          }}
        />
        <Box
          sx={{
            display: [null, null, "none"],
            mt: 4,
            mb: [null, 5],
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: ["relative"],
              left: 0,
              right: 0,
              zIndex: "100000",
            }}
          >
            <Box
              sx={{
                borderTop: "2px solid #A9D4F1",
                borderBottom: "2px solid #A9D4F1",
                py: 4,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ color: "white", fontSize: 26 }}>Stay Connected</Box>

              <a href="https://www.facebook.com/cashmoney.ca/">
                <Icons
                  size={40}
                  name={"facebook"}
                  color="white"
                  alt="facebook"
                />
              </a>
              <a href="https://www.instagram.com/cash_money1992/">
                <Icons
                  size={40}
                  name={"instagram"}
                  color="white"
                  alt="instagram"
                />
              </a>
              <a href="https://www.linkedin.com/company/cash-money/">
                <Icons
                  size={40}
                  name={"linkedin"}
                  color="white"
                  alt="linkedin"
                />
              </a>
            </Box>
            <Box
              sx={{
                color: "white",
                textAlign: "center",
                py: 4,
                a: {
                  textDecoration: "underline",
                },
              }}
            >
              <div sx={{ mb: 2 }}>
                Phone: <a href="tel:1-877-526-6639">1-877-526-6639</a>
              </div>
              <div>
                Email:{" "}
                <a href="mailto:customerservice@cashmoney.ca">
                  customerservice@cashmoney.ca
                </a>
              </div>
            </Box>
            <Box sx={{ margin: "0 auto", display: ["block", null, "none "] }}>
              <a
                href={secureLinks.loanApplication}
                sx={{
                  variant: "buttons.newPrimaryLight",
                  bg: "brand.powderBlue",
                  mx: 3,
                  margin: "0 auto",
                  display: "block",
                  py: "10px",
                  mx: "auto",
                  color: "black",
                }}
              >
                Apply Now
              </a>
            </Box>
          </Box>
        </Box>
      </Container>
    </Fragment>
  );
};
export default SubNav;
